<h2 class="first_title">Gestione dipartimenti</h2>
<div export-help></div>
<div class="content-page-wrapper">

  <div class="standardpanel">
    <div class="container_tab_nav">
      <ul class="nav nav-tabs two">
        <li [style.width.%]="50" class="{{activeTab === 0 ? 'active' : 'inactive'}}"><a data-toggle="tab"
            (click)="activeTab = 0" aria-expanded="true">Dipartimenti</a></li>
        <li [style.width.%]="50" class="{{activeTab === 1 ? 'active' : 'inactive'}}"><a data-toggle="tab"
            (click)="activeTab = 1" aria-expanded="false">Ruoli</a></li>
      </ul>
      <div class="tab-content">
  
  
        <div *ngIf="activeTab === 0" class="tab-pane fade active in">
          <app-gestione-dipartimenti></app-gestione-dipartimenti>
        </div>
  
        <div *ngIf="activeTab === 1" class="tab-pane fade active in">
          <app-gestione-ruoli></app-gestione-ruoli>
        </div>
  
  
  
      </div>
    </div>
  </div>
</div>
